import React from "react"
import RoleSelector from "./FilterPanel/RoleSelector"
import {
  useMediaQuery,
  Grid,
  AppBar,
  Toolbar,
  Divider,
  Typography,
  Box,
  IconButton,
  Tooltip,
  Button,
  InputBase,
} from "@material-ui/core"
import Resource from "./Resource/Resource"
import { FilterList, List, Close, Menu as MenuIcon } from "@material-ui/icons"
import MapIcon from "@material-ui/icons/Map"
import {
  StyledViewToggleButton,
  MainViewContainer,
  Resources,
  ResourceCardContainer,
  StyledDrawer,
  useStyles,
  ButtonDetailsStyled,
  StlyedCollapseControl,
  StyledFilterButton,
  StyledCreditsButton,
  ActiveFiltersTab,
} from "./MainViewStyles"
import WelcomeDialog from "./WelcomeDialog"
import pefLogo from "../images/LOGO_PEF.png"
import mapIcon from "../images/map-marker.png"
import winnerBadge from "../images/technically-awards-winner-badge-2025-product.png"
import { TileLayer, Marker, Popup, ZoomControl, Map } from "react-leaflet"
import * as L from "leaflet"
import { useTheme } from "@material-ui/styles"
import MoreDetailsDialog from "./MoreDetailsDialog"
import useFetchAllFilters from "../Hooks/useFetchAllFilters"
import useInterestsFilters from "../Hooks/Filters/useInterestsFilters"
import useResourcesTypeSelect from "../Hooks/Filters/useResourceTypeSelect"
import useGradeLevelFilters from "../Hooks/Filters/useGradeLevelFilters"
import useCostFilter from "../Hooks/Filters/useCostFilter"
import useTopicsFilters from "../Hooks/Filters/useTopicsFilters"
import useIncentivesFilters from "../Hooks/Filters/useIncentivesFilters"
import useDesignedForFilters from "../Hooks/Filters/useDesignedFor"
import ProfessionalFilters from "./FilterPanel/ProfessionalFilters"
import ResourceFilters from "./FilterPanel/ResourceFilters"
import runFilterCheck from "./Services/RunFilterCheck"
import useHeightObserver from "../Hooks/Utils/useHeightObserver"
import useEdStandards from "../Hooks/Filters/useEducationalStandardsOrGuidelines"
import CreditsDialog from "./CreditsDialog"
import useProgramLocationFilters from "../Hooks/Filters/useProgramLocationFilters"
import useWhenProgramOfferedFilters from "../Hooks/Filters/useWhenProgramOfferedFilters"
import useWhenPDOfferedFilters from "../Hooks/Filters/useWhenPDOfferedFilters"

const ROLE_LABELS = {
  resource: "Student or Parent/Guardian",
  professional_resource: "Teacher or Educator",
}

const MainView = () => {
  const theme = useTheme()
  const desktopView = useMediaQuery(theme.breakpoints.up("lg"))
  const isMobile = useMediaQuery(theme.breakpoints.down(650))

  const [mapState] = React.useState({
    lat: 39.9536863,
    lng: -75.1688438,
    zoom: 13,
  })

  const position = [mapState.lat, mapState.lng]

  const { size } = useHeightObserver()

  const {
    gradeLevelFilters,
    interestsFilters,
    programLocationFilters,
    whenProgramOfferedFilters,
    whenPDOfferedFilters,
    topicsFilters,
    incentivesFilters,
    designedForFilters,
    educationalStandardsOrGuidelinesFilters,
  } = useFetchAllFilters()

  const {
    gradeSelected,
    gradeLevelFiltersState,
    resetGradeLevelsChecked,
  } = useGradeLevelFilters(gradeLevelFilters)

  const {
    interestsSelected,
    interestsFiltersState,
    resetInterestsChecked,
  } = useInterestsFilters(interestsFilters)

  const {
    topicSelected,
    topicsFiltersState,
    resetTopicsChecked,
  } = useTopicsFilters(topicsFilters)

  const {
    incentiveSelected,
    incentivesFiltersState,
    resetIncentivesChecked,
  } = useIncentivesFilters(incentivesFilters)

  const {
    designedForSelected,
    designedForFiltersState,
    resetDesignedForChecked,
  } = useDesignedForFilters(designedForFilters)

  const {
    edStandardsSelected,
    edStandardsFiltersState,
    resetEdStandardsChecked,
  } = useEdStandards(educationalStandardsOrGuidelinesFilters)

  const { costSelected, costState, setCostState } = useCostFilter()

  const {
    programLocationSelected,
    programLocationFiltersState,
    resetProgramLocationChecked,
  } = useProgramLocationFilters(programLocationFilters)

  const {
    whenProgramOfferedFiltersState,
    whenProgramOfferedSelected,
    resetWhenProgramOfferedChecked,
  } = useWhenProgramOfferedFilters(whenProgramOfferedFilters)

  const {
    whenPDOfferedFiltersState,
    whenPDOfferedSelected,
    resetWhenPDOfferedChecked,
  } = useWhenPDOfferedFilters(whenPDOfferedFilters)

  const { selectedRole, setSelectedRole, resources } = useResourcesTypeSelect()

  const [filteredResources, setFilteredResources] = React.useState(null)

  const [transportationState, setTransportationState] = React.useState("Other")

  // Left Filter Panel open-closed state
  const [open, setFilterPanelState] = React.useState({
    open: true, // default filters open when page loads so users can see what's available
  })

  const [siteMenuOpen, setSiteMenuOpen] = React.useState(false)

  const [currentResourceView, setResourceView] = React.useState({
    view: "map",
  })

  // Welcome Dialog open-closed state
  const [welcomeDialog, setWelcomeDialogState] = React.useState({
    open: true,
  })

  // Credits Dialog open-closed state
  const [creditsDialog, setCreditsDialogState] = React.useState(false)
  const [moreDetailsDiag, setMoreDetailsDiagState] = React.useState({
    open: false,
    data: null,
  })

  const transportationSelected = event => {
    setTransportationState(event.target.value)
  }

  const [searchText, setSearchText] = React.useState("")

  const handleSearchChange = (value) => {
    setSearchText(value)
  }

  const handleClearSearch = () => {
    setSearchText("")
  }

  const onRoleSelectedPanel = e => {
    setSelectedRole(e.target.value)
    // Reset all resource filters
    resetAllFilters()
  }

  const resetAllFilters = () => {
    setSearchText("")
    setCostState("Other")
    setTransportationState("Other")
    resetGradeLevelsChecked()
    resetDesignedForChecked()
    resetEdStandardsChecked()
    resetIncentivesChecked()
    resetInterestsChecked()
    resetTopicsChecked()
    resetProgramLocationChecked()
    resetWhenProgramOfferedChecked()
    resetWhenPDOfferedChecked()
  }

  const toggleDrawer = () => {
    if (open.open) {
      setFilterPanelState({ open: false })
    } else {
      setSiteMenuOpen(false)
      setFilterPanelState({ open: true })
    }
  }

  const toggleSiteMenu = () => {
    if (siteMenuOpen) {
      setSiteMenuOpen(false)
    } else {
      setFilterPanelState({ open: false })
      setSiteMenuOpen(true)
    }
  }

  const toggleView = () => {
    if (currentResourceView.view === "map") {
      setResourceView({ view: "list" })
    } else {
      setResourceView({ view: "map" })
    }
  }

  const handleWelcomeDiagClose = () => {
    setWelcomeDialogState({ open: false })
  }

  const handleCreditsDiagClose = () => {
    setCreditsDialogState(false)
  }

  const handleMoreDetailsDiagClose = () => {
    setMoreDetailsDiagState({
      open: false,
      data: null,
    })
  }

  const onRoleSelected = (e, resource) => {
    setSelectedRole(resource)
    setWelcomeDialogState({ open: false })
  }

  const handleMoreDetailsDiagClick = resource => {
    setMoreDetailsDiagState({
      open: true,
      data: resource,
    })
  }

  const handleCreditsDiagClick = () => {
    setCreditsDialogState(true)
  }

  const mapHeight = { height: size - 59 }
  const resourceCardHeight = { height: size }

  // Resource API call - Move to new seperate service
  React.useEffect(() => {
    if (resources) {
      const {
        runGradeFilter,
        runInterestsFilter,
        runProgramLocationFilter,
        runWhenProgramOfferedFilter,
        runWhenPDOfferedFilter,
        runDesignedForFilter,
        runIncentivesFilter,
        runTopicsFilter,
        runEdStandardsFilter,
      } = runFilterCheck(
        gradeLevelFiltersState,
        interestsFiltersState,
        programLocationFiltersState,
        whenProgramOfferedFiltersState,
        whenPDOfferedFiltersState,
        designedForFiltersState,
        incentivesFiltersState,
        topicsFiltersState,
        edStandardsFiltersState
      )

      const filtered = resources
        .filter(resource => {
          if (runGradeFilter) {
            for (const key in resource.data.grade_level) {
              const gradeLevelId =
                resource.data.grade_level[key].grade_level_filter.id
              if (
                resource.data.grade_level[key].grade_level_filter.id in
                  gradeLevelFiltersState &&
                gradeLevelFiltersState[gradeLevelId].checked === true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          // Cost Filter
          if (!welcomeDialog.open && costState !== "Other") {
            return resource.data.cost === costState
          } else {
            return true
          }
        })
        .filter(resource => {
          // Interests Filter
          if (runInterestsFilter) {
            for (const key in resource.data.interests) {
              const interestsId =
                resource.data.interests[key].interests_filter.id
              if (
                resource.data.interests[key].interests_filter.id in
                  interestsFiltersState &&
                interestsFiltersState[interestsId].checked === true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          // Transportation Filter
          if (!welcomeDialog.open && transportationState !== "Other") {
            return resource.data.transportation === transportationState
          } else {
            return true
          }
        })
        .filter(resource => {
          if (runProgramLocationFilter) {
            for (const key in resource.data.program_location) {
              const programLocationId =
                resource.data.program_location[key].program_location_filter.id
              if (
                resource.data.program_location[key].program_location_filter
                  .id in programLocationFiltersState &&
                programLocationFiltersState[programLocationId].checked === true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          if (runWhenProgramOfferedFilter) {
            for (const key in resource.data.when_program_offered) {
              const whenProgramOfferedId =
                resource.data.when_program_offered[key]
                  .when_program_offered_filter.id
              if (
                resource.data.when_program_offered[key]
                  .when_program_offered_filter.id in
                  whenProgramOfferedFiltersState &&
                whenProgramOfferedFiltersState[whenProgramOfferedId].checked ===
                  true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          if (runWhenPDOfferedFilter) {
            for (const key in resource.data.when_pd_offered) {
              const whenPDOfferedId =
                resource.data.when_pd_offered[key].when_pd_offered_filter.id
              if (
                resource.data.when_pd_offered[key].when_pd_offered_filter.id in
                  whenPDOfferedFiltersState &&
                whenPDOfferedFiltersState[whenPDOfferedId].checked === true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          if (runDesignedForFilter) {
            for (const key in resource.data.designed_for) {
              const designedForId =
                resource.data.designed_for[key].designed_for_filter.id
              if (
                resource.data.designed_for[key].designed_for_filter.id in
                  designedForFiltersState &&
                designedForFiltersState[designedForId].checked === true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          if (runTopicsFilter) {
            for (const key in resource.data.topics) {
              const topicId = resource.data.topics[key].topics_filter.id
              if (
                resource.data.topics[key].topics_filter.id in
                  topicsFiltersState &&
                topicsFiltersState[topicId].checked === true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          if (runIncentivesFilter) {
            for (const key in resource.data.incentives) {
              const incentiveId =
                resource.data.incentives[key].incentives_filter.id
              if (
                resource.data.incentives[key].incentives_filter.id in
                  incentivesFiltersState &&
                incentivesFiltersState[incentiveId].checked === true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          if (runEdStandardsFilter) {
            for (const key in resource.data
              .educational_standards_or_guidelines) {
              const edStandardsId =
                resource.data.educational_standards_or_guidelines[key]
                  .educational_standards_or_guidelines_filter.id
              if (
                resource.data.educational_standards_or_guidelines[key]
                  .educational_standards_or_guidelines_filter.id in
                  edStandardsFiltersState &&
                edStandardsFiltersState[edStandardsId].checked === true
              ) {
                return true
              }
            }
          } else {
            return true
          }
        })
        .filter(resource => {
          const q = searchText.trim().toLowerCase()
          if (!q) return true
          const d = resource.data
          //search some fields, TBD if we need others
          const fields = [
            d.name,
            d.street,
            d.phone_number,
            d.website && d.website.url,
          ]
          return fields.some(
            field =>
              field != null &&
              String(field)
                .toLowerCase()
                .includes(q)
          )
        })
      setFilteredResources(filtered)
    }
  }, [
    resources,
    gradeLevelFiltersState,
    costState,
    transportationState,
    interestsFiltersState,
    programLocationFiltersState,
    whenProgramOfferedFiltersState,
    whenPDOfferedFiltersState,
    topicsFiltersState,
    designedForFiltersState,
    incentivesFiltersState,
    edStandardsFiltersState,
    welcomeDialog.open,
    searchText,
  ])

  const classes = useStyles()

  const activeFiltersSummary = React.useMemo(() => {
    const flags = runFilterCheck(
      gradeLevelFiltersState,
      interestsFiltersState,
      programLocationFiltersState,
      whenProgramOfferedFiltersState,
      whenPDOfferedFiltersState,
      designedForFiltersState,
      incentivesFiltersState,
      topicsFiltersState,
      edStandardsFiltersState
    )
    const facetParts = []
    if (flags.runGradeFilter) facetParts.push("Grade Level")
    if (flags.runInterestsFilter) facetParts.push("Interests")
    if (flags.runProgramLocationFilter) facetParts.push("Program Location")
    if (flags.runWhenProgramOfferedFilter) facetParts.push("When Program Offered")
    if (flags.runWhenPDOfferedFilter) facetParts.push("When PD Offered")
    if (flags.runDesignedForFilter) facetParts.push("Designed For")
    if (flags.runTopicsFilter) facetParts.push("Topics")
    if (flags.runIncentivesFilter) facetParts.push("Incentives")
    if (flags.runEdStandardsFilter) facetParts.push("Educational Standards or Guidelines")

    const costOn = !welcomeDialog.open && costState !== "Other"
    const transportOn = !welcomeDialog.open && transportationState !== "Other"
    const searchOn = searchText.trim() !== ""

    const show = true; //just always show it

    return {
      show,
      facetParts,
      costOn,
      transportOn,
      searchOn,
      searchDisplay: searchText.trim(),
    }
  }, [
    gradeLevelFiltersState,
    interestsFiltersState,
    programLocationFiltersState,
    whenProgramOfferedFiltersState,
    whenPDOfferedFiltersState,
    designedForFiltersState,
    incentivesFiltersState,
    topicsFiltersState,
    edStandardsFiltersState,
    welcomeDialog.open,
    costState,
    transportationState,
    searchText,
  ])

  let customMapIcon

  if (typeof window !== "undefined") {
    customMapIcon = new L.Icon({
      iconUrl: mapIcon,
      iconSize: [mapState.zoom * 3, mapState.zoom * 3],
    })
  } else {
    return null
  }

  const MapView = () => (
    <Map style={mapHeight} center={position} zoom={mapState.zoom} on>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
        url="https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_2szh_1_b1764d7938c59f11ace8a7cf"
      />
      <ZoomControl position="bottomright"></ZoomControl>
      {filteredResources &&
        // !welcomeDialog.open &&
        filteredResources.map((result, key) => (
          <div key={key}>
            {result.data.location !== undefined &&
              result.data.location.latitude &&
              result.data.location.longitude && (
                <Marker
                  position={[
                    result.data.location.latitude,
                    result.data.location.longitude,
                  ]}
                  icon={customMapIcon ? customMapIcon : null}
                  key={key}
                  onMouseOver={e => {
                    e.target.openPopup()
                  }}
                >
                  <Popup>
                    <Grid container spacing={1}>
                      <Grid xs={12} item>
                        <Typography variant="subtitle1">
                          {result.data.name}
                        </Typography>
                      </Grid>
                      <Grid xs={12} item>
                        <Typography variant="subtitle2">
                          {result.data.street
                            ? result.data.street
                            : "Undefined"}
                        </Typography>
                        <Typography variant="subtitle2">
                          {result.data.city}, {result.data.state},{" "}
                          {result.data.zip_code}
                        </Typography>
                      </Grid>
                      <Grid xs={12} item>
                        {result.data.description !== null && (
                          <Typography variant="subtitle2">
                            {result.data.description.substring(0, 100)}...
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                    <ButtonDetailsStyled
                      color="primary"
                      variant="text"
                      onClick={() => handleMoreDetailsDiagClick(result.data)}
                    >
                      More details
                    </ButtonDetailsStyled>
                  </Popup>
                </Marker>
              )}
          </div>
        ))}
    </Map>
  )

  return (
    <div>
      {!welcomeDialog.open && !isMobile && (
        <StyledCreditsButton
          color="secondary"
          variant="outlined"
          onClick={() => handleCreditsDiagClick()}
        >
          Credits
        </StyledCreditsButton>
      )}
      {!welcomeDialog.open && !open.open && !desktopView && (
        <StyledViewToggleButton
          onClick={toggleView}
          color="primary"
          variant="extended"
        >
          {currentResourceView.view === "list" && <MapIcon />}
          {currentResourceView.view === "map" && <List />}
          VIEW {currentResourceView.view === "map" ? "list" : "map"}
        </StyledViewToggleButton>
      )}
      <MoreDetailsDialog
        handleMoreDetailsDiagClose={handleMoreDetailsDiagClose}
        moreDetailsDialog={moreDetailsDiag}
      />
      <WelcomeDialog
        handleWelcomeDiagClose={handleWelcomeDiagClose}
        welcomeDialog={welcomeDialog}
        onRoleSelected={onRoleSelected}
        desktopView={desktopView}
        selectedRole={selectedRole}
      />
      <CreditsDialog
        handleCreditsDiagClose={handleCreditsDiagClose}
        creditsDialog={creditsDialog}
      ></CreditsDialog>
      <AppBar position="fixed" style={{background: "#00ad5f"}}>
        <Toolbar className={classes.toolbar}>
          <Box display="flex" alignItems="center" m={isMobile ? "20px 2px" : 1}>
            <img height={isMobile ? "50px" : "70px"} src={pefLogo}></img>
          </Box>
          <Box display="flex" alignItems="center" ml="auto">
            {!isMobile && (
              <Box mr={desktopView ? 3 : 0}>
                <Button
                  color="secondary"
                  style={{ padding: "6px 16px", background: "#201C6E", color: "#ffffff", boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)" }}
                  href="https://www.philastemeco.org/"
                >
                  Philadelphia STEM Ecosystem
                </Button>
              </Box>
            )}
            {isMobile && (
              <Tooltip title={siteMenuOpen ? "Close menu" : "Open menu"}>
                <IconButton
                  aria-label="toggle site menu"
                  aria-expanded={siteMenuOpen}
                  onClick={toggleSiteMenu}
                  style={{ color: "#ffffff", fontSize: "14px", background: "#201C6E", borderRadius: "4px", padding: "6px 8px" }}
                >
                  MENU <MenuIcon style={{ paddingLeft: "8px" }} />
                </IconButton>
              </Tooltip>
            )}
            <Box pl={isMobile ? 1 : 2} display="flex" alignItems="center">
              <Tooltip title="Show Filters">
                <StyledFilterButton
                  style={{ background: "#201C6E", color: "#ffffff" }}
                  aria-label="open filters"
                  onClick={toggleDrawer}
                  variant="contained"
                  color="primary"
                  startIcon={<FilterList />}
                >
                  {isMobile ? "Filters" : "Filter / Search"}
                </StyledFilterButton>
              </Tooltip>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      {activeFiltersSummary.show && (
        <ActiveFiltersTab aria-live="polite">
          <Typography
            variant="caption"
            component="div"
            style={{ fontWeight: 600, marginBottom: 2 }}
          >
            Active filters
          </Typography>
          <Typography variant="caption" component="div" color="textSecondary">
            Role: {ROLE_LABELS[selectedRole] || "—"}
          </Typography>
          {activeFiltersSummary.searchOn && (
            <Typography variant="caption" component="div">
              Search: &ldquo;{activeFiltersSummary.searchDisplay}&rdquo;
            </Typography>
          )}
          {(activeFiltersSummary.costOn ||
            activeFiltersSummary.transportOn ||
            activeFiltersSummary.facetParts.length > 0) && (
            <Typography variant="caption" component="div">
              {[
                activeFiltersSummary.costOn && "Participation fee",
                activeFiltersSummary.transportOn && "Transportation assistance",
                activeFiltersSummary.facetParts.length > 0 &&
                  activeFiltersSummary.facetParts.join(", "),
              ]
                .filter(Boolean)
                .join(", ")}
            </Typography>
          )}
        </ActiveFiltersTab>
      )}
      <StyledDrawer
        open={open.open}
        onClose={toggleDrawer}
        variant="temporary"
        anchor="right"
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        <StlyedCollapseControl
          mt={11}
          display="flex"
          justifyContent="space-between"
        >
          <Box display="flex" justifyContent="flex-start" py={2} pl={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={resetAllFilters}
            >
              Reset Filters
            </Button>
          </Box>
          <Tooltip title="Hide">
            <IconButton
              color="primary"
              aria-label="hide"
              className="hideFilterDrawer"
              onClick={toggleDrawer}
            >
              <Close fontSize="large" />
            </IconButton>
          </Tooltip>
        </StlyedCollapseControl>
        <Box>
          <form
            onSubmit={e => {
              e.preventDefault()
              if (open.open) setFilterPanelState({ open: false })
            }}
          >
            <InputBase
              placeholder="Search"
              value={searchText}
              onChange={e => handleSearchChange(e.target.value)}
              inputProps={{ "aria-label": "Search resources" }}
              style={{
                width: "65%",
                margin: "20px 20px 0px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "10px",
              }}
            />
            {searchText.trim() !== "" && (
              <Button
                type="button"
                size="small"
                onClick={handleClearSearch}
                style={{ background: "#ddd", border: "1px solid #999", borderRadius: "4px", padding: "5px", margin: "8px 8px 0 20px", textTransform: "none", display: "inline-block" }}
              >
                Clear Search
              </Button>
            )}
          </form>
          <RoleSelector
            selectedRole={selectedRole}
            onRoleSelected={onRoleSelectedPanel}
          ></RoleSelector>
          <Divider />
          <div>
            {selectedRole === "resource" && (
              <ResourceFilters
                gradeSelected={gradeSelected}
                gradeLevelFiltersState={gradeLevelFiltersState}
                interestsSelected={interestsSelected}
                interestsFiltersState={interestsFiltersState}
                programLocationSelected={programLocationSelected}
                programLocationFiltersState={programLocationFiltersState}
                whenProgramOfferedSelected={whenProgramOfferedSelected}
                whenProgramOfferedFiltersState={whenProgramOfferedFiltersState}
                costSelected={costSelected}
                costState={costState}
                transportationSelected={transportationSelected}
                transportationState={transportationState}
              ></ResourceFilters>
            )}
            {selectedRole === "professional_resource" && (
              <ProfessionalFilters
                gradeSelected={gradeSelected}
                gradeLevelFiltersState={gradeLevelFiltersState}
                designedForSelected={designedForSelected}
                designedForFiltersState={designedForFiltersState}
                topicSelected={topicSelected}
                topicsFiltersState={topicsFiltersState}
                incentiveSelected={incentiveSelected}
                incentivesFiltersState={incentivesFiltersState}
                whenPDOfferedSelected={whenPDOfferedSelected}
                whenPDOfferedFiltersState={whenPDOfferedFiltersState}
                educationalStandardsOrGuidelinesSelected={edStandardsSelected}
                educationalStandardsOrGuidelinesFiltersState={
                  edStandardsFiltersState
                }
              ></ProfessionalFilters>
            )}
          </div>
        </Box>
        <Box p={2}>
          <Button
              variant="contained"
              color="primary"
              onClick={toggleDrawer}
            >
              Close Filters
            </Button>
        </Box>
      </StyledDrawer>

      <StyledDrawer
        open={siteMenuOpen}
        onClose={() => setSiteMenuOpen(false)}
        variant="temporary"
        anchor="left"
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          width={280}
          maxWidth="85vw"
          style={{ padding: "30px 20px" }}
        >
          <Box display="flex" justifyContent="flex-end" mb={1} mt={8}>
            <Tooltip title="Close">
              <IconButton
                aria-label="close site menu"
                onClick={() => setSiteMenuOpen(false)}
                color="primary"
              >
                <Close fontSize="large" />
              </IconButton>
            </Tooltip>
          </Box>
          <Box display="flex" justifyContent="center" mb={2}>
            <a href="https://technical.ly/entrepreneurship/technically-awards-winners-2025-philly" target="_blank"><img
              alt="Technically Awards 2025 Product winner"
              width="200"
              style={{ maxWidth: "100%", height: "auto" }}
              src={winnerBadge}
            /></a>
          </Box>
          <Button
            color="secondary"
            fullWidth
            style={{
              padding: "10px 16px",
              background: "#201C6E",
              color: "#ffffff",
              boxShadow:
                "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
              marginBottom: 12,
            }}
            href="https://www.philastemeco.org/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setSiteMenuOpen(false)}
          >
            Philadelphia STEM Ecosystem
          </Button>
          <Button
            color="secondary"
            variant="outlined"
            fullWidth
            onClick={() => {
              handleCreditsDiagClick()
              setSiteMenuOpen(false)
            }}
          >
            Credits
          </Button>
        </Box>
      </StyledDrawer>

      <MainViewContainer style={mapHeight}>
        <Grid container>
          {desktopView && (
            <Grid item xs={3}>
              <ResourceCardContainer style={resourceCardHeight}>
                <Resources>
                  <Box display="flex" alignItems="center" justifyContent="center">
                    <a href="https://technical.ly/entrepreneurship/technically-awards-winners-2025-philly" target="_blank">
                      <img maxWidth="100%" width="200px" height="auto" style={{ margin: "auto" }} src={winnerBadge}></img>
                    </a>
                  </Box>
                  {filteredResources &&
                    !welcomeDialog.open &&
                    filteredResources.map((result, key) => (
                      <Grid item xs={12} key={key}>
                        <Resource key={key} data={result.data}></Resource>
                      </Grid>
                    ))}
                </Resources>
              </ResourceCardContainer>
            </Grid>
          )}
          {desktopView && (
            <Grid item xs={9}>
              {typeof window !== "undefined" ? <MapView></MapView> : null}
            </Grid>
          )}
          {!desktopView && currentResourceView.view === "map" && (
            <Grid item xs={12}>
              {typeof window !== "undefined" ? <MapView></MapView> : null}
            </Grid>
          )}
          {!desktopView && currentResourceView.view === "list" && (
            <Grid item xs={12}>
              <ResourceCardContainer style={resourceCardHeight}>
                <Resources>
                  {!isMobile && (
                    <Box display="flex" alignItems="center" justifyContent="center">
                      <a href="https://technical.ly/entrepreneurship/technically-awards-winners-2025-philly" target="_blank">
                        <img maxWidth="100%" width="200px" height="auto" style={{ margin: "auto" }} src={winnerBadge}></img>
                      </a>
                    </Box>
                  )}
                  {filteredResources &&
                    !welcomeDialog.open &&
                    filteredResources.map((result, key) => (
                      <Grid item xs={12} key={key}>
                        <Resource key={key} data={result.data}></Resource>
                      </Grid>
                    ))}
                </Resources>
              </ResourceCardContainer>
            </Grid>
          )}
        </Grid>
      </MainViewContainer>
    </div>
  )
}

export default MainView
